import { wrappedActionTypes } from './constants';
import { ChapterItem } from '../types';

export interface WrappedState {
	loading: boolean;
	availableChapters: ChapterItem[];
	error: any | null;
}

const initialState: WrappedState = {
	loading: false,
	availableChapters: [],
	error: null,
};

export default function wrappedReducer(state = initialState, action: any) {
	const { type, payload } = action;

	switch (type) {
		case wrappedActionTypes.GET_YEAR_SUMMARY_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};

		case wrappedActionTypes.GET_YEAR_SUMMARY_SUCCESS:
			return {
				...state,
				loading: false,
				availableChapters: payload.availableChapters,
				error: null,
			};

		case wrappedActionTypes.GET_YEAR_SUMMARY_ERROR:
			return {
				...state,
				loading: false,
				error: payload.error,
			};

		default:
			return state;
	}
}
